import { rem } from 'design-system';
import { isIOS } from '../../constants';
export const NETWORTH_PAGE_CONTROL_HEIGHT = rem(41);
export const NETWORTH_PAGE_CONTROL_HEIGHT_WITH_PADDING = NETWORTH_PAGE_CONTROL_HEIGHT + rem(16);
export const OVERVIEW_PAGE_CONTROL_HEIGHT = rem(65);
const CHART_INFO_HEIGHT = rem(126);
const CHART_WITH_CONTROLS_HEIGHT = rem(331);
const TOTAL_CHART_HEIGHT = CHART_INFO_HEIGHT + CHART_WITH_CONTROLS_HEIGHT;
const TOTAL_CHART_HEIGHT_ANDROID = rem(468);
export const TOTAL_OVERVIEW_HEADER_HEIGHT = OVERVIEW_PAGE_CONTROL_HEIGHT +
    (isIOS ? TOTAL_CHART_HEIGHT : TOTAL_CHART_HEIGHT_ANDROID) +
    rem(16);
